const techPactHomeURL =process.env.REACT_APP_TECHPACT_HOME_URL;


export default techPactHomeURL